import Header from "@/types/app/header";

export class ImportInterestHeader {
  public static header: Header[] = [
    {
      text: "Email",
      align: "start",
      sortable: true,
      value: "Email",
      class: "item-table-header",
      width: ""
    },
    {
      text: "First Name",
      align: "start",
      sortable: true,
      value: "FirstName",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Last Name",
      align: "start",
      sortable: true,
      value: "LastName",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Country",
      align: "start",
      sortable: true,
      value: "Country",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Phone",
      align: "start",
      sortable: true,
      value: "Phone",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Classification",
      align: "start",
      sortable: true,
      value: "Classification",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Type Person",
      align: "start",
      sortable: true,
      value: "TypePerson",
      class: "item-table-header",
      width: ""
    },
    {
      text: "", align: "right", value: "actions", sortable: false, class: null,
      width: "" }
  ];
}

export class ImportAccountHeader {
  public static header: Header[] = [
    {
      text: "Email",
      align: "start",
      sortable: true,
      value: "Email",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Account Number",
      align: "start",
      sortable: true,
      value: "AccountNumber",
      class: "item-table-header",
      width: ""
    },
    {
      text: "Fund Name",
      align: "start",
      sortable: true,
      value: "FundName",
      class: "item-table-header",
      width: ""
    },
    {
      text: "", align: "right", value: "actions", sortable: false, class: null,
      width: "" 
    }
  ];
}
